class FeaturedCollectionSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.sliderComponent = document.querySelector(`#collection-${sectionId} slider-component`);
    if (!this.sliderComponent) return;

    this.init();
  }

  init() {
    const mobilePrev = this.sliderComponent.querySelector('button[name="previous-mobile"]');
    const mobileNext = this.sliderComponent.querySelector('button[name="next-mobile"]');
    const desktopPrev = this.sliderComponent.querySelector('button[name="previous"]');
    const desktopNext = this.sliderComponent.querySelector('button[name="next"]');
    const desktopCurrent = this.sliderComponent.querySelector('.slider-buttons--desktop .slider-counter--current');
    const mobileCurrent = this.sliderComponent.querySelector('.large-up-hide.medium-hide .slider-counter--current');
    const desktopTotal = this.sliderComponent.querySelector('.slider-buttons--desktop .slider-counter--total');
    const mobileTotal = this.sliderComponent.querySelector('.large-up-hide.medium-hide .slider-counter--total');

    // Helper function to pad numbers with leading zeros
    const padNumber = (num) => {
      const number = parseInt(num);
      return number < 10 ? '0' + number : number.toString();
    };

    // Format a counter element's text content
    const formatCounter = (element) => {
      if (!element) return;
      const currentText = element.textContent.trim();
      const paddedText = padNumber(currentText);
      if (currentText !== paddedText) {
        element.textContent = paddedText;
      }
    };

    // Sync mobile and desktop counters
    if (mobilePrev && desktopPrev) {
      mobilePrev.addEventListener('click', () => {
        desktopPrev.click();
      });
    }

    if (mobileNext && desktopNext) {
      mobileNext.addEventListener('click', () => {
        desktopNext.click();
      });
    }

    const syncCounters = () => {
      if (desktopCurrent && mobileCurrent) {
        mobileCurrent.textContent = desktopCurrent.textContent;
      }
      if (desktopTotal && mobileTotal) {
        mobileTotal.textContent = desktopTotal.textContent;
      }
    };

    const updateMobileTotal = () => {
      if (mobileTotal && this.sliderComponent.totalPages) {
        mobileTotal.textContent = this.sliderComponent.totalPages;
      }
    };

    const initializeSync = () => {
      if (this.sliderComponent.totalPages) {
        updateMobileTotal();
        syncCounters();
      } else {
        setTimeout(initializeSync, 100);
      }
    };

    setTimeout(initializeSync, 100);

    // Use MutationObserver to format numbers when they change
    const counters = [desktopCurrent, mobileCurrent, desktopTotal, mobileTotal].filter(Boolean);

    counters.forEach((counter) => {
      const observer = new MutationObserver(() => {
        formatCounter(counter);
      });

      observer.observe(counter, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      // Format initial value
      formatCounter(counter);
    });

    // Sync between desktop and mobile
    if (desktopCurrent && mobileCurrent) {
      const syncObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            syncCounters();
          }
        });
      });

      syncObserver.observe(desktopCurrent, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      if (desktopTotal) {
        syncObserver.observe(desktopTotal, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    const slider = this.sliderComponent.querySelector('[id^="Slider-"]');
    if (slider) {
      slider.addEventListener('scroll', () => {
        setTimeout(() => {
          syncCounters();
          updateMobileTotal();
        }, 50);
      });
    }

    this.sliderComponent.addEventListener('slideChanged', () => {
      syncCounters();
      updateMobileTotal();
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initializeSync();
      }, 250);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const featuredCollectionSections = document.querySelectorAll('[id^="collection-"]');
  featuredCollectionSections.forEach((section) => {
    const sectionId = section.id.replace('collection-', '');
    const sliderComponent = section.querySelector('slider-component');
    const hasMobileButtons = sliderComponent && sliderComponent.querySelector('button[name="previous-mobile"]');
    const hasDesktopButtons = sliderComponent && sliderComponent.querySelector('button[name="previous"]');

    if (hasMobileButtons || hasDesktopButtons) {
      new FeaturedCollectionSlider(sectionId);
    }
  });
});
